export default __webpack_public_path__ + "static/logo-d4a1a2b479627312fd96ecedf657d35e.png";